// extracted by mini-css-extract-plugin
export default {"root":"header_root__X6hXM","sectionHeader":"header_sectionHeader__BWN37"};